interface MultiSelectToggleProps {
  options: string[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export function MultiSelectToggle({ options, selected, onChange }: MultiSelectToggleProps) {
  const toggle = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter((v) => v !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            onClick={() => toggle(option)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
              isSelected
                ? "bg-bauwerk-teal text-white border-bauwerk-teal"
                : "bg-white text-gray-700 border-gray-300 hover:border-bauwerk-teal hover:text-bauwerk-teal"
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
